var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.uploadtype == "img"
    ? _c(
        "el-upload",
        _vm._b(
          {
            staticClass: "singleimg-uploader",
            attrs: {
              uploadimg: "",
              accept: "image/*",
              "show-file-list": false,
              action: _vm.uploadUrl,
              "on-success": _vm.uploadSuccess,
              "on-error": _vm.handleError,
              "before-upload": _vm.handleBeforeUpload,
              "on-progress": _vm.handleProgress,
              data: _vm.data,
              headers: _vm.headers,
              name: _vm.filename,
              single: ""
            }
          },
          "el-upload",
          _vm._d({}, [_vm.rawhttp, _vm.customUpload])
        ),
        [
          _vm.imgurl && !_vm.uploading
            ? _c("img", {
                staticClass: "singleimg",
                attrs: { src: _vm.imgurl }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.imgurl && !_vm.uploading
            ? _c("i", { staticClass: "el-icon-plus singleimg-uploader-icon" })
            : _vm._e(),
          _vm._v(" "),
          _vm.uploading
            ? _c("el-progress", {
                staticClass: "singleimg progress",
                attrs: { percentage: _vm.percent, type: "circle" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showtips
            ? _c("div", {
                staticClass: "el-upload__tip",
                attrs: { slot: "tip" },
                domProps: { textContent: _vm._s(_vm.getTips()) },
                slot: "tip"
              })
            : _vm._e()
        ],
        1
      )
    : _vm.uploadtype == "imglist"
    ? _c(
        "el-upload",
        _vm._b(
          {
            attrs: {
              uploadimg: "",
              drag: "",
              "list-type": "picture",
              limit: Number(_vm.maxlength),
              "file-list": _vm.imglist,
              "on-remove": _vm.handleRemove,
              action: _vm.uploadUrl,
              accept: "image/*",
              "on-success": _vm.uploadSuccess,
              "on-error": _vm.handleError,
              "on-preview": _vm.showPicDialog,
              "on-exceed": _vm.onExceed,
              "before-upload": _vm.handleBeforeUpload,
              data: _vm.data,
              headers: _vm.headers,
              name: _vm.filename,
              multiple: ""
            }
          },
          "el-upload",
          _vm._d({}, [_vm.rawhttp, _vm.customUpload])
        ),
        [
          _c("i", { staticClass: "el-icon-upload" }),
          _vm._v(" "),
          _c("div", { staticClass: "el-upload__text" }, [
            _vm._v("将文件拖到此处，或"),
            _c("em", [_vm._v("点击上传")])
          ]),
          _vm._v(" "),
          _vm.showtips
            ? _c("div", {
                staticClass: "el-upload__tip",
                attrs: { slot: "tip" },
                domProps: { textContent: _vm._s(_vm.getTips()) },
                slot: "tip"
              })
            : _vm._e()
        ]
      )
    : _vm.uploadtype == "imgcard"
    ? _c(
        "el-upload",
        {
          attrs: {
            uploadimgcard: "",
            multiple: "",
            action: _vm.uploadUrl,
            "list-type": "picture-card",
            "on-success": _vm.uploadSuccess,
            "on-preview": _vm.showPicDialog,
            "on-remove": _vm.handleRemove
          }
        },
        [_c("i", { staticClass: "el-icon-plus" })]
      )
    : _vm.uploadtype == "fileurl"
    ? _c(
        "el-upload",
        _vm._b(
          {
            ref: "upload",
            attrs: {
              uploadfile: "",
              single: "",
              accept: _vm.accept,
              "file-list": _vm.filelist,
              action: _vm.uploadUrl,
              "on-success": _vm.uploadSuccess,
              "on-error": _vm.handleError,
              "on-remove": _vm.handleRemove,
              "before-upload": _vm.handleBeforeUpload,
              data: _vm.data,
              headers: _vm.headers,
              name: _vm.filename
            }
          },
          "el-upload",
          _vm._d({}, [_vm.rawhttp, _vm.customUpload])
        ),
        [
          _c("el-button", { attrs: { size: "small", type: "primary" } }, [
            _vm._v(_vm._s(_vm.btntext))
          ]),
          _vm._v(" "),
          _vm.showtips
            ? _c("div", {
                staticClass: "el-upload__tip",
                attrs: { slot: "tip" },
                domProps: { textContent: _vm._s(_vm.getTips()) },
                slot: "tip"
              })
            : _vm._e()
        ],
        1
      )
    : _vm.uploadtype == "filelist"
    ? _c(
        "el-upload",
        _vm._b(
          {
            attrs: {
              "file-list": _vm.filelist,
              drag: "",
              uploadfile: "",
              multiple: "",
              limit: Number(_vm.maxlength),
              action: _vm.uploadUrl,
              "on-success": _vm.uploadSuccess,
              "on-error": _vm.handleError,
              "on-remove": _vm.handleRemove,
              "on-exceed": _vm.onExceed,
              "before-upload": _vm.handleBeforeUpload,
              data: _vm.data,
              headers: _vm.headers,
              name: _vm.filename
            }
          },
          "el-upload",
          _vm._d({}, [_vm.rawhttp, _vm.customUpload])
        ),
        [
          _c("i", { staticClass: "el-icon-upload" }),
          _vm._v(" "),
          _c("div", { staticClass: "el-upload__text" }, [
            _vm._v("将文件拖到此处，或"),
            _c("em", [_vm._v("点击上传")])
          ]),
          _vm._v(" "),
          _vm.showtips
            ? _c("div", {
                staticClass: "el-upload__tip",
                attrs: { slot: "tip" },
                domProps: { textContent: _vm._s(_vm.getTips()) },
                slot: "tip"
              })
            : _vm._e()
        ]
      )
    : _vm.uploadtype == "importfile"
    ? _c(
        "el-upload",
        _vm._b(
          {
            ref: "upload",
            attrs: {
              uploadfile: "",
              single: "",
              "auto-upload": _vm.autoupload,
              accept: _vm.accept,
              "file-list": _vm.filelist,
              action: _vm.uploadUrl,
              "on-success": _vm.uploadSuccess,
              "on-error": _vm.handleError,
              "on-remove": _vm.handleRemove,
              "on-change": _vm.handleChange,
              "before-upload": _vm.handleBeforeUpload,
              data: _vm.data,
              headers: _vm.headers,
              name: _vm.filename
            }
          },
          "el-upload",
          _vm._d({}, [_vm.rawhttp, _vm.customUpload])
        ),
        [
          _c(
            "el-button",
            {
              attrs: { slot: "trigger", size: "small", type: "primary" },
              slot: "trigger"
            },
            [_vm._v(_vm._s(_vm.btntext))]
          ),
          _vm._v(" "),
          _vm.showbeginbtn && _vm.autoupload == false
            ? _c(
                "el-button",
                {
                  attrs: { size: "small", type: "success" },
                  on: { click: _vm.submitUpload }
                },
                [_vm._v(_vm._s(_vm.beginbtntext))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showtips
            ? _c("div", {
                staticClass: "el-upload__tip",
                attrs: { slot: "tip" },
                domProps: { textContent: _vm._s(_vm.getTips()) },
                slot: "tip"
              })
            : _vm._e()
        ],
        1
      )
    : _vm.uploadtype == "importlist"
    ? _c(
        "el-upload",
        _vm._b(
          {
            staticClass: "my-upload",
            attrs: {
              accept: _vm.accept,
              "file-list": _vm.filelist,
              limit: Number(_vm.maxlength),
              "show-file-list": _vm.toshowlist,
              action: _vm.uploadUrl,
              "on-success": _vm.uploadSuccess,
              "on-error": _vm.handleError,
              "before-upload": _vm.handleBeforeUpload,
              "on-progress": _vm.handleProgress,
              data: _vm.data,
              headers: _vm.headers,
              name: _vm.filename,
              multiple: ""
            }
          },
          "el-upload",
          _vm._d({}, [_vm.rawhttp, _vm.customUpload])
        ),
        [
          _c("el-button", { attrs: { size: "small", type: "primary" } }, [
            _vm._v(_vm._s(_vm.btntext))
          ]),
          _vm._v(" "),
          _vm.showtips
            ? _c("div", {
                staticClass: "el-upload__tip",
                attrs: { slot: "tip" },
                domProps: { textContent: _vm._s(_vm.getTips()) },
                slot: "tip"
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36e1087d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e1087d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyUpload.vue
// module id = 2FTl
// module chunks = 38